import React from "react";
import moment from "moment";
import { DownloadIcon } from "../Icons";
import { getPresignedUrlForFile } from "../../api/helperapi/helperApi";
import downloadFileFromS3 from "../../utils/helper";

const EmailRecordModal = ({ show, handleClose, emailRecords = [], setPdfModalInfo }) => {
    if (!show) return null; // Don't render if closed

    console.log('Email record ::', emailRecords);

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={handleClose}
        >
            {/* Modal Container */}
            <div
                className="bg-white rounded-2xl shadow-2xl w-[90vw] max-w-6xl max-h-[90vh] overflow-hidden flex flex-col"
                onClick={(e) => e.stopPropagation()} // Prevent closing on inner click
            >
                {/* Header */}
                <div className="flex justify-between items-center border-b px-6 py-4">
                    <h2 className="text-xl font-semibold">Email Records</h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-gray-700 transition"
                    >
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-auto p-4">
                    <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden text-sm">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="text-left p-3 border-b">Sent To</th>
                                <th className="text-left p-3 border-b">Subject</th>
                                <th className="text-left p-3 border-b whitespace-nowrap">
                                    Updated Date
                                </th>
                                <th className="text-left p-3 border-b">Attachments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emailRecords?.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center p-6 text-gray-500">
                                        No records found
                                    </td>
                                </tr>
                            ) : (
                                emailRecords?.sort((a, b) => moment(b.updatedDate).valueOf() - moment(a.updatedDate).valueOf())
                                    ?.map((record, idx) => (
                                        <tr
                                            key={idx}
                                            className="hover:bg-gray-50 transition-colors border-b"
                                        >
                                            <td className="p-3">{record.sentToEmail}</td>
                                            <td className="p-3">{record.emailSubject}</td>
                                            <td className="p-3">
                                                {moment(record.updatedDate).format(
                                                    "DD MMM YYYY hh:mm:ss a"
                                                )}
                                            </td>
                                            <td className="p-3">
                                                {record.attachments && record.attachments.length > 0 ? (
                                                    <ul className="list-disc pl-5 space-y-1">
                                                        {record.attachments.map((attachment, attachIdx) => (
                                                            <li key={attachIdx}>
                                                                <div className="flex items-center gap-2">
                                                                    <span
                                                                        className="truncate flex-1"
                                                                        title={
                                                                            attachment.originalname ||
                                                                            attachment.filename
                                                                        }
                                                                    >
                                                                        {attachment.originalname ||
                                                                            attachment.filename}
                                                                    </span>
                                                                    <button
                                                                        className="text-blue-600 hover:text-blue-800 transition"
                                                                        title="Download file"
                                                                        onClick={async () => {
                                                                            const { originalname } = attachment;
                                                                            if (
                                                                                originalname &&
                                                                                originalname.endsWith(".pdf")
                                                                            ) {
                                                                                const signedUrl =
                                                                                    await getPresignedUrlForFile(
                                                                                        attachment.bucket,
                                                                                        attachment.key
                                                                                    );
                                                                                setPdfModalInfo && setPdfModalInfo({
                                                                                    show: true,
                                                                                    pdfUrl: signedUrl,
                                                                                    fileName: originalname,
                                                                                });
                                                                                handleClose();
                                                                                return;
                                                                            }
                                                                            await downloadFileFromS3(attachment);
                                                                        }}
                                                                    >
                                                                        <DownloadIcon />
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <span className="text-gray-400">No attachments</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Footer */}
                <div className="border-t px-6 py-4 flex justify-end">
                    <button
                        onClick={handleClose}
                        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-gray-700 font-medium transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmailRecordModal;
